// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Assessment Timer & Beautiful UI Styles
   ============================================ */

/* ============================================
   Assessment Header Container
   ============================================ */

.assessment-header-container {
  margin-bottom: 25px;
}

.assessment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 20px 25px;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
  flex-wrap: wrap;
  gap: 20px;
}

.assessment-info {
  flex: 1 1;
  min-width: 200px;
}

.assessment-title {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
}

.assessment-meta {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.meta-item {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  display: flex;
  align-items: center;
}

.meta-item i {
  margin-right: 5px;
}

/* ============================================
   Timer Styles
   ============================================ */

.timer-container {
  background: white;
  border-radius: 15px;
  padding: 15px 25px;
  min-width: 200px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.timer-not-started {
  text-align: center;
}

.timer-running {
  text-align: center;
}

.timer-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
}

.timer-icon i {
  font-size: 24px;
  color: white;
}

.timer-icon.animated i {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.timer-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timer-label {
  font-size: 11px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.timer-value {
  font-size: 32px;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  color: #333;
  line-height: 1;
}

.timer-value.success { color: #28a745; }
.timer-value.warning { color: #ffc107; }
.timer-value.danger { color: #dc3545; }

.timer-hint {
  font-size: 10px;
  color: #999;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timer-progress {
  height: 6px;
  border-radius: 3px;
  margin-top: 12px;
}

/* Timer Warning States */
.timer-container.timer-warning {
  border: 2px solid #ffc107;
  animation: warningPulse 1s infinite;
}

.timer-container.timer-critical {
  border: 2px solid #dc3545;
  animation: criticalPulse 0.5s infinite;
}

@keyframes warningPulse {
  0%, 100% { box-shadow: 0 5px 20px rgba(255, 193, 7, 0.3); }
  50% { box-shadow: 0 5px 30px rgba(255, 193, 7, 0.5); }
}

@keyframes criticalPulse {
  0%, 100% { box-shadow: 0 5px 20px rgba(220, 53, 69, 0.3); }
  50% { box-shadow: 0 5px 30px rgba(220, 53, 69, 0.6); }
}

/* ============================================
   Question Navigation
   ============================================ */

.question-navigation {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 15px;
  padding: 15px 20px;
  margin-top: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  gap: 15px;
}

.nav-label {
  font-size: 13px;
  font-weight: 600;
  color: #666;
}

.question-dots {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
}

.question-dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  background: white;
  color: #666;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-dot:hover {
  border-color: #667eea;
  color: #667eea;
}

.question-dot.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
  transform: scale(1.1);
}

.question-dot.answered {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.question-dot.answered.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
}

.answered-count {
  font-size: 13px;
  color: #28a745;
  font-weight: 600;
  display: flex;
  align-items: center;
}

/* ============================================
   Assessment Card & Questions
   ============================================ */

.assessment-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.question-container {
  padding: 10px;
}

.question-header {
  margin-bottom: 20px;
}

.question-number {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 18px;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 600;
}

.question-text {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
}

.question-image {
  max-width: 100%;
  border-radius: 10px;
  margin-top: 15px;
}

/* ============================================
   Option Buttons
   ============================================ */

.options-container {
  margin-top: 25px;
}

.option-button {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 15px 20px;
  border-radius: 12px;
  border-width: 2px;
  min-height: 60px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.option-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.option-button.selected {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  border-color: #28a745 !important;
  color: white !important;
}

.option-letter-badge {
  width: 32px;
  height: 32px;
  background: rgba(102, 126, 234, 0.15);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  flex-shrink: 0;
}

.option-button.selected .option-letter-badge {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}

.option-text {
  flex: 1 1;
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

/* Option Image Mode */
.option-image-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid transparent;
  transition: all 0.3s ease;
}

.option-image-wrapper:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.option-image-wrapper.selected {
  border-color: #28a745;
}

.option-image {
  width: 100%;
  display: block;
}

.option-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
}

.option-overlay .option-letter {
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}

/* ============================================
   Action Buttons
   ============================================ */

.action-buttons {
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.nav-button {
  padding: 12px 25px;
  border-radius: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.submit-button {
  padding: 12px 30px;
  border-radius: 10px;
  font-weight: 600;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  display: flex;
  align-items: center;
}

.submit-button:hover {
  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(40, 167, 69, 0.4);
}

/* ============================================
   Results Container
   ============================================ */

.results-container {
  padding: 20px;
}

.results-header {
  text-align: center;
  margin-bottom: 30px;
}

.results-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #ffc107 0%, #ffdb4d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.results-icon i {
  font-size: 40px;
  color: white;
}

.results-header h2 {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.results-header p {
  color: #666;
  font-size: 14px;
}

/* Score Card */
.score-card {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 25px;
  gap: 20px;
}

.score-item {
  text-align: center;
}

.score-value {
  display: block;
  font-size: 48px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.score-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.score-divider {
  font-size: 36px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 300;
}

.score-percentage {
  background: white;
  color: #667eea;
  padding: 15px 25px;
  border-radius: 15px;
  font-size: 28px;
  font-weight: 700;
}

/* Results Stats */
.results-stats {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.stat-box {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}

.stat-box i {
  font-size: 18px;
  margin-right: 8px;
}

.stat-box.answered {
  background: #e8f5e9;
  color: #28a745;
}

.stat-box.unanswered {
  background: #ffebee;
  color: #dc3545;
}

/* Review Section */
.review-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #eee;
}

.review-question {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 20px;
}

.review-question-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.question-num {
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}

/* Review Options */
.review-option {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 15px;
  transition: all 0.2s ease;
}

.review-option.correct {
  border-color: #28a745;
  background: #e8f5e9;
}

.review-option.wrong {
  border-color: #dc3545;
  background: #ffebee;
}

.review-option .option-letter-badge {
  margin-right: 12px;
}

.review-option .option-text {
  font-size: 13px;
}

.correct-icon {
  color: #28a745;
  margin-left: auto;
  font-size: 18px;
}

.wrong-icon {
  color: #dc3545;
  margin-left: auto;
  font-size: 18px;
}

.review-option-image {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid transparent;
}

.review-option-image img {
  width: 100%;
  display: block;
}

.review-option-image.correct {
  border-color: #28a745;
}

.review-option-image.wrong {
  border-color: #dc3545;
}

.correct-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: #28a745;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.results-actions {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.back-button {
  padding: 12px 30px;
  border-radius: 10px;
  font-weight: 600;
}

/* ============================================
   Time Up Modal
   ============================================ */

.time-up-modal .modal-content {
  border: none;
  border-radius: 20px;
  overflow: hidden;
}

.time-up-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.time-up-icon i {
  font-size: 50px;
  color: white;
}

.time-up-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.time-up-message {
  color: #666;
  font-size: 16px;
  margin-bottom: 25px;
}

.submitting-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.submitting-indicator p {
  color: #666;
  margin: 0;
}

.view-results-btn {
  padding: 12px 30px;
  border-radius: 10px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.view-results-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 767.98px) {
  .assessment-header {
    flex-direction: column;
    padding: 15px;
  }

  .assessment-title {
    font-size: 18px;
  }

  .timer-container {
    width: 100%;
    padding: 15px;
  }

  .timer-value {
    font-size: 28px;
  }

  .question-navigation {
    padding: 12px 15px;
  }

  .question-dot {
    width: 30px;
    height: 30px;
    font-size: 11px;
  }

  .question-text {
    font-size: 16px;
  }

  .option-button {
    padding: 12px 15px;
  }

  .option-letter-badge {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .score-card {
    flex-wrap: wrap;
    padding: 20px;
  }

  .score-value {
    font-size: 36px;
  }

  .score-percentage {
    width: 100%;
    text-align: center;
    margin-top: 15px;
  }
}

@media (max-width: 575.98px) {
  .meta-item {
    font-size: 12px;
  }

  .timer-icon {
    width: 40px;
    height: 40px;
  }

  .timer-icon i {
    font-size: 20px;
  }

  .timer-value {
    font-size: 24px;
  }

  .question-dot {
    width: 28px;
    height: 28px;
    font-size: 10px;
  }

  .answered-count {
    width: 100%;
    justify-content: center;
    margin-top: 10px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .nav-button, .submit-button {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/assessment-timer.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,cAAc;AAChB;;AAEA,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,sBAAsB,cAAc,EAAE;;AAEtC;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,6CAA6C,EAAE;AACvD;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* ============================================\n   Assessment Timer & Beautiful UI Styles\n   ============================================ */\n\n/* ============================================\n   Assessment Header Container\n   ============================================ */\n\n.assessment-header-container {\n  margin-bottom: 25px;\n}\n\n.assessment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 20px;\n  padding: 20px 25px;\n  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.assessment-info {\n  flex: 1;\n  min-width: 200px;\n}\n\n.assessment-title {\n  color: white;\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n}\n\n.assessment-meta {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.meta-item {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n}\n\n.meta-item i {\n  margin-right: 5px;\n}\n\n/* ============================================\n   Timer Styles\n   ============================================ */\n\n.timer-container {\n  background: white;\n  border-radius: 15px;\n  padding: 15px 25px;\n  min-width: 200px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.timer-not-started {\n  text-align: center;\n}\n\n.timer-running {\n  text-align: center;\n}\n\n.timer-icon {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 10px;\n}\n\n.timer-icon i {\n  font-size: 24px;\n  color: white;\n}\n\n.timer-icon.animated i {\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.timer-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.timer-label {\n  font-size: 11px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n}\n\n.timer-value {\n  font-size: 32px;\n  font-weight: 700;\n  font-family: 'Courier New', monospace;\n  color: #333;\n  line-height: 1;\n}\n\n.timer-value.success { color: #28a745; }\n.timer-value.warning { color: #ffc107; }\n.timer-value.danger { color: #dc3545; }\n\n.timer-hint {\n  font-size: 10px;\n  color: #999;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.timer-progress {\n  height: 6px;\n  border-radius: 3px;\n  margin-top: 12px;\n}\n\n/* Timer Warning States */\n.timer-container.timer-warning {\n  border: 2px solid #ffc107;\n  animation: warningPulse 1s infinite;\n}\n\n.timer-container.timer-critical {\n  border: 2px solid #dc3545;\n  animation: criticalPulse 0.5s infinite;\n}\n\n@keyframes warningPulse {\n  0%, 100% { box-shadow: 0 5px 20px rgba(255, 193, 7, 0.3); }\n  50% { box-shadow: 0 5px 30px rgba(255, 193, 7, 0.5); }\n}\n\n@keyframes criticalPulse {\n  0%, 100% { box-shadow: 0 5px 20px rgba(220, 53, 69, 0.3); }\n  50% { box-shadow: 0 5px 30px rgba(220, 53, 69, 0.6); }\n}\n\n/* ============================================\n   Question Navigation\n   ============================================ */\n\n.question-navigation {\n  display: flex;\n  align-items: center;\n  background: white;\n  border-radius: 15px;\n  padding: 15px 20px;\n  margin-top: 15px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.nav-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #666;\n}\n\n.question-dots {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n}\n\n.question-dot {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: 2px solid #e0e0e0;\n  background: white;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.question-dot:hover {\n  border-color: #667eea;\n  color: #667eea;\n}\n\n.question-dot.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-color: #667eea;\n  color: white;\n  transform: scale(1.1);\n}\n\n.question-dot.answered {\n  background: #28a745;\n  border-color: #28a745;\n  color: white;\n}\n\n.question-dot.answered.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-color: #667eea;\n}\n\n.answered-count {\n  font-size: 13px;\n  color: #28a745;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n\n/* ============================================\n   Assessment Card & Questions\n   ============================================ */\n\n.assessment-card {\n  border: none;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.question-container {\n  padding: 10px;\n}\n\n.question-header {\n  margin-bottom: 20px;\n}\n\n.question-number {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8px 18px;\n  border-radius: 25px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.question-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  line-height: 1.5;\n}\n\n.question-image {\n  max-width: 100%;\n  border-radius: 10px;\n  margin-top: 15px;\n}\n\n/* ============================================\n   Option Buttons\n   ============================================ */\n\n.options-container {\n  margin-top: 25px;\n}\n\n.option-button {\n  display: flex;\n  align-items: center;\n  text-align: left;\n  padding: 15px 20px;\n  border-radius: 12px;\n  border-width: 2px;\n  min-height: 60px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.option-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.option-button.selected {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;\n  border-color: #28a745 !important;\n  color: white !important;\n}\n\n.option-letter-badge {\n  width: 32px;\n  height: 32px;\n  background: rgba(102, 126, 234, 0.15);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n  margin-right: 15px;\n  flex-shrink: 0;\n}\n\n.option-button.selected .option-letter-badge {\n  background: rgba(255, 255, 255, 0.3);\n  color: white;\n}\n\n.option-text {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n/* Option Image Mode */\n.option-image-wrapper {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 3px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.option-image-wrapper:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.option-image-wrapper.selected {\n  border-color: #28a745;\n}\n\n.option-image {\n  width: 100%;\n  display: block;\n}\n\n.option-overlay {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n}\n\n.option-overlay .option-letter {\n  width: 30px;\n  height: 30px;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n/* ============================================\n   Action Buttons\n   ============================================ */\n\n.action-buttons {\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.nav-button {\n  padding: 12px 25px;\n  border-radius: 10px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n\n.submit-button {\n  padding: 12px 30px;\n  border-radius: 10px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  border: none;\n  display: flex;\n  align-items: center;\n}\n\n.submit-button:hover {\n  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(40, 167, 69, 0.4);\n}\n\n/* ============================================\n   Results Container\n   ============================================ */\n\n.results-container {\n  padding: 20px;\n}\n\n.results-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.results-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #ffc107 0%, #ffdb4d 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n}\n\n.results-icon i {\n  font-size: 40px;\n  color: white;\n}\n\n.results-header h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.results-header p {\n  color: #666;\n  font-size: 14px;\n}\n\n/* Score Card */\n.score-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 20px;\n  padding: 30px;\n  margin-bottom: 25px;\n  gap: 20px;\n}\n\n.score-item {\n  text-align: center;\n}\n\n.score-value {\n  display: block;\n  font-size: 48px;\n  font-weight: 700;\n  color: white;\n  line-height: 1;\n}\n\n.score-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.score-divider {\n  font-size: 36px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 300;\n}\n\n.score-percentage {\n  background: white;\n  color: #667eea;\n  padding: 15px 25px;\n  border-radius: 15px;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n/* Results Stats */\n.results-stats {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.stat-box {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.stat-box i {\n  font-size: 18px;\n  margin-right: 8px;\n}\n\n.stat-box.answered {\n  background: #e8f5e9;\n  color: #28a745;\n}\n\n.stat-box.unanswered {\n  background: #ffebee;\n  color: #dc3545;\n}\n\n/* Review Section */\n.review-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #eee;\n}\n\n.review-question {\n  background: #f8f9fa;\n  border-radius: 15px;\n  padding: 20px;\n}\n\n.review-question-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.question-num {\n  width: 30px;\n  height: 30px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n/* Review Options */\n.review-option {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 12px 15px;\n  transition: all 0.2s ease;\n}\n\n.review-option.correct {\n  border-color: #28a745;\n  background: #e8f5e9;\n}\n\n.review-option.wrong {\n  border-color: #dc3545;\n  background: #ffebee;\n}\n\n.review-option .option-letter-badge {\n  margin-right: 12px;\n}\n\n.review-option .option-text {\n  font-size: 13px;\n}\n\n.correct-icon {\n  color: #28a745;\n  margin-left: auto;\n  font-size: 18px;\n}\n\n.wrong-icon {\n  color: #dc3545;\n  margin-left: auto;\n  font-size: 18px;\n}\n\n.review-option-image {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 3px solid transparent;\n}\n\n.review-option-image img {\n  width: 100%;\n  display: block;\n}\n\n.review-option-image.correct {\n  border-color: #28a745;\n}\n\n.review-option-image.wrong {\n  border-color: #dc3545;\n}\n\n.correct-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background: #28a745;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.results-actions {\n  text-align: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.back-button {\n  padding: 12px 30px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n/* ============================================\n   Time Up Modal\n   ============================================ */\n\n.time-up-modal .modal-content {\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.time-up-icon {\n  width: 100px;\n  height: 100px;\n  background: linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 25px;\n  animation: shake 0.5s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-10px); }\n  75% { transform: translateX(10px); }\n}\n\n.time-up-icon i {\n  font-size: 50px;\n  color: white;\n}\n\n.time-up-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.time-up-message {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 25px;\n}\n\n.submitting-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.submitting-indicator p {\n  color: #666;\n  margin: 0;\n}\n\n.view-results-btn {\n  padding: 12px 30px;\n  border-radius: 10px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n}\n\n.view-results-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 767.98px) {\n  .assessment-header {\n    flex-direction: column;\n    padding: 15px;\n  }\n\n  .assessment-title {\n    font-size: 18px;\n  }\n\n  .timer-container {\n    width: 100%;\n    padding: 15px;\n  }\n\n  .timer-value {\n    font-size: 28px;\n  }\n\n  .question-navigation {\n    padding: 12px 15px;\n  }\n\n  .question-dot {\n    width: 30px;\n    height: 30px;\n    font-size: 11px;\n  }\n\n  .question-text {\n    font-size: 16px;\n  }\n\n  .option-button {\n    padding: 12px 15px;\n  }\n\n  .option-letter-badge {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .score-card {\n    flex-wrap: wrap;\n    padding: 20px;\n  }\n\n  .score-value {\n    font-size: 36px;\n  }\n\n  .score-percentage {\n    width: 100%;\n    text-align: center;\n    margin-top: 15px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .meta-item {\n    font-size: 12px;\n  }\n\n  .timer-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .timer-icon i {\n    font-size: 20px;\n  }\n\n  .timer-value {\n    font-size: 24px;\n  }\n\n  .question-dot {\n    width: 28px;\n    height: 28px;\n    font-size: 10px;\n  }\n\n  .answered-count {\n    width: 100%;\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .nav-button, .submit-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
